module.exports = __webpack_public_path__ + "static/media/test21_1.0bbfb318.png";